import { X } from 'lucide-react';
import type { ParsedKml } from '../../../../utils/kml';
import type { RelatorioVisitaPonto } from '../../schemas/payload.schema';
import GlebaMapa from './gleba-mapa';

const ALTURA_MAPA_SEM_HEADER = 620;

interface MapaTalhaoModalProps {
  titulo: string;
  parsed: ParsedKml;
  pontos: RelatorioVisitaPonto[];
  open: boolean;
  onClose: () => void;
  semHeader?: boolean;
}

const MapaTalhaoModal = ({
  titulo,
  parsed,
  pontos,
  open,
  onClose,
  semHeader = false,
}: MapaTalhaoModalProps) => {
  if (!open) return null;

  const dialogClass = semHeader
    ? 'rv-mapa-modal-dialog rv-mapa-modal-dialog--sem-header'
    : 'rv-mapa-modal-dialog';

  return (
    <div
      role="presentation"
      className="rv-mapa-modal-overlay"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
      onKeyDown={(event) => {
        if (event.key === 'Escape') onClose();
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label={titulo}
        className={dialogClass}
      >
        {semHeader ? (
          <button
            type="button"
            aria-label="Fechar"
            onClick={onClose}
            className="rv-mapa-modal-close rv-mapa-modal-close--flutuante"
          >
            <X size={20} />
          </button>
        ) : (
          <div className="rv-mapa-modal-header">
            <h2 className="rv-mapa-modal-title">{titulo}</h2>
            <button
              type="button"
              aria-label="Fechar"
              onClick={onClose}
              className="rv-mapa-modal-close"
            >
              <X size={20} />
            </button>
          </div>
        )}

        <div className="rv-mapa-modal-body">
          <GlebaMapa
            altura={semHeader ? ALTURA_MAPA_SEM_HEADER : undefined}
            parsed={parsed}
            pontos={pontos}
          />
        </div>
      </div>
    </div>
  );
};

export default MapaTalhaoModal;
